export default __webpack_public_path__ + "98fffe948ebd7b88d322a4747e87e554.svg";